<template>
  <div>
    <v-dialog
        v-model="dialog"
        persistent
        :width="printType==='visa_number'?'450':'800'"
    >
      <v-card>
        <v-toolbar color="blue darken-3" dark>
          <v-toolbar-title>Print</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-4">
          <div v-html="content"></div>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
              @click="cancel"
              class="white--text"
              color="red darken-3"
          >Cancel
          </v-btn>
          <v-btn
              class="white--text"
              color="blue darken-3"
              @click="print"
          >Print
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div v-html="content" class="show-on-print"></div>
  </div>
</template>

<script>
import {CLOSE_PRINT_CONTENT, SET_PRINT_TYPE} from "../../store/mutation-type";


export default {
  name: "PrintDialog",
  props: ['value'],
  data() {
    return {
      paymentData: {},
    }
  },
  computed: {
    content() {
      return this.$store.state.Print.content;
    },
    dialog() {
      return this.$store.state.Print.dialog;
    },
    printType() {
      return this.$store.state.Print.printType;
    }
  },
  methods: {
    cancel() {
      this.$store.commit(CLOSE_PRINT_CONTENT)
      this.$store.commit(SET_PRINT_TYPE, null)
    },
    print() {
      window.print()
      this.$store.commit(SET_PRINT_TYPE, null)
    }
  }
}
</script>

